var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 9.16658C10.4602 9.16658 10.8333 9.53968 10.8333 9.99991V13.3332C10.8333 13.7935 10.4602 14.1666 9.99993 14.1666C9.53969 14.1666 9.1666 13.7935 9.1666 13.3332V9.99991C9.1666 9.53968 9.53969 9.16658 9.99993 9.16658Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 5.83325C9.53969 5.83325 9.1666 6.20635 9.1666 6.66659C9.1666 7.12682 9.53969 7.49992 9.99993 7.49992H10.0083C10.4685 7.49992 10.8416 7.12682 10.8416 6.66659C10.8416 6.20635 10.4685 5.83325 10.0083 5.83325H9.99993Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 9.99992C0.833252 4.93731 4.93731 0.833252 9.99992 0.833252C15.0625 0.833252 19.1666 4.93731 19.1666 9.99992C19.1666 15.0625 15.0625 19.1666 9.99992 19.1666C4.93731 19.1666 0.833252 15.0625 0.833252 9.99992ZM9.99992 2.49992C5.85778 2.49992 2.49992 5.85778 2.49992 9.99992C2.49992 14.1421 5.85778 17.4999 9.99992 17.4999C14.1421 17.4999 17.4999 14.1421 17.4999 9.99992C17.4999 5.85778 14.1421 2.49992 9.99992 2.49992Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.72e127d9.svg";
export { ForwardRef as ReactComponent };